import { memo, useCallback, useMemo } from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { authService } from 'services';
import { ERROR_IMAGE } from 'settings';
import { Divider } from 'shared';
import { selectUser } from 'store/selectors';
import { checkCookies } from 'utils/Cookies';

import LogoutAccount from '../Logout';
import { Container, Content, Item, Title, Wrapper } from './styles';

interface IProps {
  position?: 'left' | 'right';
}

const AccountList: React.FC<IProps> = ({ position = 'left' }) => {
  const { accounts, id } = useSelector(selectUser);
  const navigate = useNavigate();

  const accountList = accounts.filter(account => account.id !== id);
  const showList = accountList.length >= 1 && checkCookies();

  const handleSwitchAccount = useCallback(
    async (id: number) => {
      await authService.switchAccount(id);

      if (window.location.pathname !== '/orderbump') {
        navigate('/', { replace: true });
      }
    },
    [navigate]
  );

  const changeTitle = useMemo(() => (accountLength: number) => accountLength > 1 ? 'Contas:' : 'Conta:', []);

  return (
    <Container position={position}>
      {showList ? (
        <Wrapper>
          <Title>{changeTitle(accounts.length)}</Title>
          <Content>
            {accountList.map(item => (
              <Item
                key={item.id}
                onClick={() => {
                  handleSwitchAccount(item.id);
                }}
              >
                <img
                  src={item.photo}
                  alt={item.name}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = ERROR_IMAGE;
                  }}
                />{' '}
                <span>{item.name}</span>
              </Item>
            ))}
          </Content>
          <Divider />
          <LogoutAccount />
        </Wrapper>
      ) : (
        <LogoutAccount />
      )}
    </Container>
  );
};
export default memo(AccountList);
